import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import TableHeader from "../../../../components/Tables/TableHeader";
import { Link } from "react-router-dom";
import { ECsArray } from "../../arrays/ECsArray";
import getNameByID from "../../../../../functions/getNameByID";
import { Get_All_From_MongoDB } from "../../../../api/Get_All_From_MongoDB";
import getNestedPropByID from "../../../../../functions/getNestedPropByID";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

function TableOfViewECs({ ECs }) {
  const { logout } = StaffuseAuth();

  //The below gets the Agencies
  const [Agencies, setAgencies] = useState([]);
  useEffect(() => {
    Get_All_From_MongoDB("IP", "Agencies", setAgencies, logout);
  }, []);

  //-----------------------------Begin Sorting---------------------------------------------
  // Assuming the rest of your component is defined here
  const [sortField, setSortField] = useState("Rating"); // Default sort by 'Text'
  const [sortDirection, setSortDirection] = useState("desc"); // 'asc' or 'desc'

  // Function To sort table
  const sortArray = (ECs, field, direction) => {
    return ECs.sort((a, b) => {
      if (a[field] < b[field]) return direction === "asc" ? -1 : 1;
      if (a[field] > b[field]) return direction === "asc" ? 1 : -1;
      return 0;
    });
  };

  //-----------------------------Sorting---------------------------------------------

  // Sort table when sortField or sortDirection changes
  const sortedECs = sortArray([...ECs], sortField, sortDirection);

  // Function To handle header click
  const handleHeaderClick = (field) => {
    if (field === sortField) {
      // Toggle sort direction
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc"); // Default To ascending when changing sort field
    }
  };
  //-----------------------------Return---------------------------------------------

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: "95%",
        maxHeight: "800px",
        flexGrow: 1,
        p: 1,
      }}
    >
      <Typography variant="h6" gutterBottom>
        View EC's
      </Typography>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          margin: "0 auto",
          overflow: "auto",
        }}
      >
        <Table
          aria-label="simple table"
          sx={{
            border: "1px solid #e0e0e0",
            tableLayout: "fixed",
          }}
        >
          <TableHead>
            <TableRow>
              {TableHeader("Agency", handleHeaderClick, "Agency_id")}
              {ECsArray.map((prop) => {
                return (
                  <>{TableHeader(prop.Name, handleHeaderClick, prop.Field)}</>
                );
              })}
              {TableHeader("View", handleHeaderClick, "Name")}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedECs.map((EC, index) => (
              <TableRow
                key={EC._id}
                sx={{
                  "&:hover": {
                    backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                    "& .MuiTableCell-root": {
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word", // Adjust padding here to make cells smaller
                    },
                  },
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {getNameByID(
                    Agencies,
                    EC.MetaData.Agency_id,
                    "BasicInfo.Name"
                  )}
                  {getNestedPropByID(
                    Agencies,
                    EC.MetaData.Agency_id,
                    "Name",
                    "BasicInfo"
                  )}
                </TableCell>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {EC.BasicInfo && EC.BasicInfo["First_Name"]
                      ? EC.BasicInfo["First_Name"]
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {EC.BasicInfo && EC.BasicInfo["Last_Name"]
                      ? EC.BasicInfo["Last_Name"]
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {EC.BasicInfo && EC.BasicInfo["Email"]
                      ? EC.BasicInfo["Email"]
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {EC.BasicInfo && EC.BasicInfo["Number"]
                      ? EC.BasicInfo["Number"]
                      : ""}
                  </TableCell>
                </>
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {EC.BasicInfo && EC.BasicInfo["Commision"]
                      ? EC.BasicInfo["Commision"]
                      : ""}
                  </TableCell>
                </>
                {/* New TableCell for update action using Link */}
                <TableCell
                  align="left"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  <Link
                    to={`/Staff/ViewEC/${EC._id}/${EC.MetaData.Agency_id}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <button>View</button>
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default TableOfViewECs;
